/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/flr.svg'
import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const flrPage: ICoinPageData = {
  title: 'coin_410',
  description: 'coin_411',
  // description: 'coin_412',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Flare (FLR)' }) }} />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_413',
        answer: 'coin_414',
      },
      {
        title: 'coin_415',
        answer: 'coin_416',
      },
      {
        title: 'coin_417',
        answer: 'coin_418',
      },
      {
        title: 'coin_419',
        answer: 'coin_420',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('FLR'),
    text: [],
    paragraphs: [
      {
        title: 'coin_421',
        text: ['coin_423'],
      },
      {
        title: 'coin_422',
        text: ['coin_424'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/flr/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_2400/https://coinrabbit.io/blog/wp-content/uploads/2023/06/Gain-profit-1.jpg',
        imageAlt: 'Hold FLR & Gain profit',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
